<template>
  <div>
    <div class="row mt-1">
      <div class="col-md-6">
        <a-form
          v-if="
            formReady && currentConfig.table && currentConfig.table.preParagraph
          "
          :form="form"
        >
          <a-tabs default-active-key="1">
            <!-- En-tête Tab -->
            <a-tab-pane
              key="1"
              :tab="$t('bulletinBuilder.enTete')"
              :forceRender="true"
            >
              <div class="row border-bottom">
                <div class="col-md-12">
                  <a-form-item :label="$t('conseilClass.orientation')">
                    <div class="d-flex align-items-center">
                      <a-switch
                        :checkedChildren="$t('conseilClass.landscape')"
                        :unCheckedChildren="$t('conseilClass.portrait')"
                        v-decorator="[
                          'orientation',
                          {
                            initialValue: currentConfig.orientation,
                            valuePropName: 'checked',
                          },
                        ]"
                      >
                      </a-switch>
                    </div>
                  </a-form-item>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 border-bottom">
                  <a-form-item :label="$t('conseilClass.govText')">
                    <a-switch
                      v-decorator="[
                        'headers.govText.allow',
                        {
                          initialValue: currentConfig.headers.govText.allow,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                  </a-form-item>
                </div>
                <div class="col-md-3 border-bottom">
                  <a-form-item :label="$t('conseilClass.useSchoolCode')">
                    <a-checkbox
                      v-decorator="[
                        'headers.govText.useSchoolCode',
                        {
                          initialValue:
                            currentConfig.headers.govText.useSchoolCode,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                  </a-form-item>
                </div>
                <div class="col-md-3 border-bottom">
                  <a-form-item :label="$t('etablissement.delegeRegional')">
                    <a-checkbox
                      v-decorator="[
                        'headers.govText.useRegionalText',
                        {
                          initialValue:
                            currentConfig.headers.govText.useRegionalText,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                  </a-form-item>
                </div>
                <div class="col-md-3 border-bottom">
                  <a-form-item :label="$t('bulletin.className')">
                    <a-checkbox
                      v-decorator="[
                        'headers.govText.useClassName',
                        {
                          initialValue:
                            currentConfig.headers.govText.useClassName,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                  </a-form-item>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 border-bottom">
                  <div class="d-flex align-items-center">
                    <a-form-item :label="$t('conseilClass.schoolLogo')">
                      <a-switch
                        v-decorator="[
                          'headers.schoolLogo.allow',
                          {
                            initialValue:
                              currentConfig.headers.schoolLogo.allow,
                            valuePropName: 'checked',
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                </div>

                <div class="col-md-3 border-right border-bottom">
                  <div class="d-flex align-items-center">
                    <a-form-item :label="$t('bulletinBuilder.taille')">
                      <a-input
                        type="number"
                        :min="0.1"
                        :max="3.0"
                        :step="0.1"
                        v-decorator="[
                          'headers.schoolLogo.scale',
                          {
                            initialValue:
                              currentConfig.headers.schoolLogo.scale || 1,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                </div>

                <div class="col-md-3 border-bottom">
                  <a-form-item :label="$t('conseilClass.schoolYear')">
                    <a-switch
                      v-decorator="[
                        'headers.schoolYear.allow',
                        {
                          initialValue: currentConfig.headers.schoolYear.allow,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                  </a-form-item>
                </div>
                <div class="col-md-3 border-bottom">
                  <a-form-item :label="$t('conseilClass.rect')">
                    <a-checkbox
                      v-decorator="[
                        'headers.schoolYear.rect',
                        {
                          initialValue: currentConfig.headers.schoolYear.rect,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                  </a-form-item>
                </div>

                <div class="col-md-3 border-bottom">
                  <a-form-item :label="$t('conseilClass.govLog')">
                    <div class="d-flex align-items-center">
                      <a-switch
                        v-decorator="[
                          'headers.govLog.allow',
                          {
                            initialValue: currentConfig.headers.govLog.allow,
                            valuePropName: 'checked',
                          },
                        ]"
                      />
                    </div>
                  </a-form-item>
                </div>

                <div class="col-md-3 border-right border-bottom">
                  <div class="d-flex align-items-center">
                    <a-form-item :label="$t('bulletinBuilder.taille')">
                      <a-input
                        type="number"
                        :min="0.1"
                        :max="3.0"
                        :step="0.1"
                        v-decorator="[
                          'headers.govLog.scale',
                          {
                            initialValue:
                              currentConfig.headers.govLog.scale || 1,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                </div>

                <div class="col-md-3 border-bottom">
                  <a-form-item :label="$t('conseilClass.stats')">
                    <a-switch
                      v-decorator="[
                        'headers.stats.allow',
                        {
                          initialValue: currentConfig.headers.stats.allow,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                  </a-form-item>
                </div>
                <div class="col-md-3 border-bottom">
                  <a-form-item :label="$t('conseilClass.rect')">
                    <a-checkbox
                      v-decorator="[
                        'headers.stats.rect',
                        {
                          initialValue: currentConfig.headers.stats.rect,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                  </a-form-item>
                </div>

                <div class="col-md-6 border-bottom">
                  <a-form-item :label="$t('conseilClass.mainTitle')">
                    <div class="d-flex align-items-center">
                      <a-switch
                        v-decorator="[
                          'headers.mainTitle.allow',
                          {
                            initialValue: currentConfig.headers.mainTitle.allow,
                            valuePropName: 'checked',
                          },
                        ]"
                      />
                      <a-button
                        type="dashed"
                        icon="setting"
                        class="ml-3"
                        shape="circle"
                        @click="showSetting('mainTitle')"
                      />
                    </div>
                  </a-form-item>
                </div>
                <div class="col-md-6 border-bottom">
                  <div class="row">
                    <a-form-item
                      :label="$t('conseilClass.secondaryText')"
                      class="col-md-12"
                    >
                      <a-switch
                        v-decorator="[
                          'headers.secondaryText.allow',
                          {
                            initialValue:
                              currentConfig.headers.secondaryText.allow,
                            valuePropName: 'checked',
                          },
                        ]"
                      />
                      <a-button
                        type="dashed"
                        icon="setting"
                        class="ml-3"
                        shape="circle"
                        @click="showSetting('secondaryText')"
                      />
                    </a-form-item>
                  </div>
                </div>
              </div>
            </a-tab-pane>
            <a-tab-pane key="2" tab="Tableau des admis" :forceRender="true">
              <a-divider orientation="left">{{
                $t("conseilClass.preParagraph")
              }}</a-divider>
              <div class="row mt-2">
                <div class="col-md-6">
                  <a-form-item :label="$t('conseilClass.allow')">
                    <a-switch
                      v-decorator="[
                        'table.preParagraph.allow',
                        {
                          initialValue: currentConfig.table.preParagraph.allow,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                  </a-form-item>
                </div>
                <div class="col-md-6">
                  <a-form-item :label="$t('conseilClass.rect')">
                    <a-switch
                      v-decorator="[
                        'table.preParagraph.rect',
                        {
                          initialValue: currentConfig.table.preParagraph.rect,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                  </a-form-item>
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-md-12">
                  <div class="d-flex align-items-center">
                    <quill-editor
                      :value="currentConfig.table.preParagraph.richText"
                      :options="editorOptions"
                      @change="updateAdminQuill"
                    />
                  </div>
                </div>
              </div>
              <a-divider orientation="left">{{
                $t("conseilClass.table")
              }}</a-divider>
              <div class="row">
                <div class="col-md-6 row">
                  <div class="col-md-6">
                    <a-form-item :label="$t('conseilClass.number')">
                      <div class="d-flex align-items-center">
                        <a-switch
                          v-decorator="[
                            'table.number',
                            {
                              initialValue: currentConfig.table.number,
                              valuePropName: 'checked',
                            },
                          ]"
                          @change="
                            ($event) => attachDettachFromTable($event, 'number')
                          "
                        />
                        <a-button
                          type="dashed"
                          icon="setting"
                          class="ml-3"
                          shape="circle"
                          @click="showTableSetting('number')"
                        />
                      </div>
                    </a-form-item>
                  </div>

                  <div class="col-md-6">
                    <a-form-item :label="$t('conseilClass.fullName')">
                      <div class="d-flex align-items-center">
                        <a-switch
                          v-decorator="[
                            'table.fullName',
                            {
                              initialValue: currentConfig.table.fullName,
                              valuePropName: 'checked',
                            },
                          ]"
                          @change="
                            ($event) =>
                              attachDettachFromTable($event, 'fullName')
                          "
                        />
                        <a-button
                          type="dashed"
                          icon="setting"
                          class="ml-3"
                          shape="circle"
                          @click="showTableSetting('fullName')"
                        />
                      </div>
                    </a-form-item>
                  </div>

                  <div class="col-md-6">
                    <a-form-item :label="$t('conseilClass.firstName')">
                      <div class="d-flex align-items-center">
                        <a-switch
                          v-decorator="[
                            'table.firstName',
                            {
                              initialValue: currentConfig.table.firstName,
                              valuePropName: 'checked',
                            },
                          ]"
                          @change="
                            ($event) =>
                              attachDettachFromTable($event, 'firstName')
                          "
                        />
                        <a-button
                          type="dashed"
                          icon="setting"
                          class="ml-3"
                          shape="circle"
                          @click="showTableSetting('firstName')"
                        />
                      </div>
                    </a-form-item>
                  </div>

                  <div class="col-md-6">
                    <a-form-item :label="$t('conseilClass.lastName')">
                      <div class="d-flex align-items-center">
                        <a-switch
                          v-decorator="[
                            'table.lastName',
                            {
                              initialValue: currentConfig.table.lastName,
                              valuePropName: 'checked',
                            },
                          ]"
                          @change="
                            ($event) =>
                              attachDettachFromTable($event, 'lastName')
                          "
                        />
                        <a-button
                          type="dashed"
                          icon="setting"
                          class="ml-3"
                          shape="circle"
                          @click="showTableSetting('lastName')"
                        />
                      </div>
                    </a-form-item>
                  </div>

                  <div class="col-md-6">
                    <a-form-item :label="$t('liste.sexe')">
                      <div class="d-flex align-items-center">
                        <a-switch
                          v-decorator="[
                            'table.gender',
                            {
                              initialValue: currentConfig.table.gender,
                              valuePropName: 'checked',
                            },
                          ]"
                          @change="
                            ($event) => attachDettachFromTable($event, 'gender')
                          "
                        />
                        <a-button
                          type="dashed"
                          icon="setting"
                          class="ml-3"
                          shape="circle"
                          @click="showTableSetting('gender')"
                        />
                      </div>
                    </a-form-item>
                  </div>

                  <div class="col-md-6">
                    <a-form-item :label="$t('conseilClass.birthDate')">
                      <div class="d-flex align-items-center">
                        <a-switch
                          v-decorator="[
                            'table.birthDate',
                            {
                              initialValue: currentConfig.table.birthDate,
                              valuePropName: 'checked',
                            },
                          ]"
                          @change="
                            ($event) =>
                              attachDettachFromTable($event, 'birthDate')
                          "
                        />
                        <a-button
                          type="dashed"
                          icon="setting"
                          class="ml-3"
                          shape="circle"
                          @click="showTableSetting('birthDate')"
                        />
                      </div>
                    </a-form-item>
                  </div>

                  <div class="col-md-6">
                    <a-form-item :label="$t('conseilClass.birthPlace')">
                      <div class="d-flex align-items-center">
                        <a-switch
                          v-decorator="[
                            'table.birthPlace',
                            {
                              initialValue: currentConfig.table.birthPlace,
                              valuePropName: 'checked',
                            },
                          ]"
                          @change="
                            ($event) =>
                              attachDettachFromTable($event, 'birthPlace')
                          "
                        />
                        <a-button
                          type="dashed"
                          icon="setting"
                          class="ml-3"
                          shape="circle"
                          @click="showTableSetting('birthPlace')"
                        />
                      </div>
                    </a-form-item>
                  </div>

                  <div class="col-md-6">
                    <a-form-item :label="$t('conseilClass.uniqueIden')">
                      <div class="d-flex align-items-center">
                        <a-switch
                          v-decorator="[
                            'table.uniqueIden',
                            {
                              initialValue: currentConfig.table.uniqueIden,
                              valuePropName: 'checked',
                            },
                          ]"
                          @change="
                            ($event) =>
                              attachDettachFromTable($event, 'uniqueIden')
                          "
                        />
                        <a-button
                          type="dashed"
                          icon="setting"
                          class="ml-3"
                          shape="circle"
                          @click="showTableSetting('uniqueIden')"
                        />
                      </div>
                    </a-form-item>
                  </div>

                  <div class="col-md-6">
                    <a-form-item :label="$t('conseilClass.prevYears')">
                      <div class="d-flex align-items-center">
                        <a-switch
                          v-decorator="[
                            'table.prevYears',
                            {
                              initialValue: currentConfig.table.prevYears,
                              valuePropName: 'checked',
                            },
                          ]"
                          @change="
                            ($event) =>
                              attachDettachFromTable($event, 'prevYears')
                          "
                        />
                        <a-button
                          type="dashed"
                          icon="setting"
                          class="ml-3"
                          shape="circle"
                          @click="showTableSetting('prevYears')"
                        />
                      </div>
                    </a-form-item>
                  </div>

                  <div class="col-md-6">
                    <a-form-item :label="$t('conseilClass.trim1')">
                      <div class="d-flex align-items-center">
                        <a-switch
                          v-decorator="[
                            'table.trim1',
                            {
                              initialValue: currentConfig.table.trim1,
                              valuePropName: 'checked',
                            },
                          ]"
                          @change="
                            ($event) => attachDettachFromTable($event, 'trim1')
                          "
                        />
                        <a-button
                          type="dashed"
                          icon="setting"
                          class="ml-3"
                          shape="circle"
                          @click="showTableSetting('trim1')"
                        />
                      </div>
                    </a-form-item>
                  </div>

                  <div class="col-md-6">
                    <a-form-item :label="$t('conseilClass.trim2')">
                      <div class="d-flex align-items-center">
                        <a-switch
                          v-decorator="[
                            'table.trim2',
                            {
                              initialValue: currentConfig.table.trim2,
                              valuePropName: 'checked',
                            },
                          ]"
                          @change="
                            ($event) => attachDettachFromTable($event, 'trim2')
                          "
                        />
                        <a-button
                          type="dashed"
                          icon="setting"
                          class="ml-3"
                          shape="circle"
                          @click="showTableSetting('trim2')"
                        />
                      </div>
                    </a-form-item>
                  </div>

                  <div class="col-md-6">
                    <a-form-item :label="$t('conseilClass.trim3')">
                      <div class="d-flex align-items-center">
                        <a-switch
                          v-decorator="[
                            'table.trim3',
                            {
                              initialValue: currentConfig.table.trim3,
                              valuePropName: 'checked',
                            },
                          ]"
                          @change="
                            ($event) => attachDettachFromTable($event, 'trim3')
                          "
                        />
                        <a-button
                          type="dashed"
                          icon="setting"
                          class="ml-3"
                          shape="circle"
                          @click="showTableSetting('trim3')"
                        />
                      </div>
                    </a-form-item>
                  </div>

                  <div class="col-md-6">
                    <a-form-item :label="$t('conseilClass.moy')">
                      <div class="d-flex align-items-center">
                        <a-switch
                          v-decorator="[
                            'table.moy',
                            {
                              initialValue: currentConfig.table.moy,
                              valuePropName: 'checked',
                            },
                          ]"
                          @change="
                            ($event) => attachDettachFromTable($event, 'moy')
                          "
                        />
                        <a-button
                          type="dashed"
                          icon="setting"
                          class="ml-3"
                          shape="circle"
                          @click="showTableSetting('moy')"
                        />
                      </div>
                    </a-form-item>
                  </div>

                  <div class="col-md-6">
                    <a-form-item :label="$t('conseilClass.decision')">
                      <div class="d-flex align-items-center">
                        <a-switch
                          v-decorator="[
                            'table.decision',
                            {
                              initialValue: currentConfig.table.decision,
                              valuePropName: 'checked',
                            },
                          ]"
                          @change="
                            ($event) =>
                              attachDettachFromTable($event, 'decision')
                          "
                        />
                        <a-button
                          type="dashed"
                          icon="setting"
                          class="ml-3"
                          shape="circle"
                          @click="showTableSetting('decision')"
                        />
                      </div>
                    </a-form-item>
                  </div>

                  <div class="col-md-6">
                    <a-form-item :label="$t('conseilClass.handicape')">
                      <div class="d-flex align-items-center">
                        <a-switch
                          v-decorator="[
                            'table.handicape',
                            {
                              initialValue: currentConfig.table.handicape,
                              valuePropName: 'checked',
                            },
                          ]"
                          @change="
                            ($event) =>
                              attachDettachFromTable($event, 'handicape')
                          "
                        />
                        <a-button
                          type="dashed"
                          icon="setting"
                          class="ml-3"
                          shape="circle"
                          @click="showTableSetting('handicape')"
                        />
                      </div>
                    </a-form-item>
                  </div>
                </div>
                <div class="col-md-6">
                  <draggable
                    v-model="avaibleColumnsTableAdmin"
                    :options="{ animation: 200 }"
                    class="drag-container"
                  >
                    <div
                      v-for="(element, index) in avaibleColumnsTableAdmin"
                      :key="'draggableColum_' + element"
                      class="drag-chip"
                    >
                      <span class="circle-number">{{ index + 1 }}</span>
                      <span v-if="element == 'gender'">{{
                        $t("liste.sexe")
                      }}</span>
                      <span v-else>{{ $t("conseilClass." + element) }}</span>
                    </div>
                  </draggable>
                </div>
              </div>
              <a-divider orientation="left">{{
                $t("conseilClass.postParagraph")
              }}</a-divider>
              <div class="row mt-2">
                <div class="col-md-6">
                  <a-form-item :label="$t('conseilClass.tablePostParagraph')">
                    <a-switch
                      v-decorator="[
                        'table.postParagraph.allow',
                        {
                          initialValue: currentConfig.table.postParagraph.allow,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                  </a-form-item>
                </div>
                <div class="col-md-6">
                  <a-form-item :label="$t('conseilClass.rect')">
                    <a-switch
                      v-decorator="[
                        'table.postParagraph.rect',
                        {
                          initialValue: currentConfig.table.postParagraph.rect,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                  </a-form-item>
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-md-12">
                  <div class="d-flex align-items-center">
                    <quill-editor
                      :value="currentConfig.table.postParagraph.richText"
                      :options="editorOptions"
                      @change="updateAdminPostQuill"
                    />
                  </div>
                </div>
              </div>
            </a-tab-pane>
            <a-tab-pane key="3" tab="Autre Tableux" :forceRender="true">
              <a-divider orientation="left"
                >Pableaux des Admis provisoires:</a-divider
              >
              <div class="row mt-2">
                <div class="col-md-4">
                  <a-form-item :label="$t('conseilClass.exceptionalStats')">
                    <a-switch
                      v-decorator="[
                        'footer.exceptionalPass.allow',
                        {
                          initialValue:
                            currentConfig.footer.exceptionalPass.allow,
                          valuePropName: 'checked',
                        },
                      ]"
                      @change="
                        (val) => setFooterField('exceptionalPass', 'allow', val)
                      "
                    />
                  </a-form-item>
                </div>
                <div class="col-md-4">
                  <a-form-item :label="$t('conseilClass.filled')">
                    <a-switch
                      v-decorator="[
                        'footer.exceptionalPass.filled',
                        {
                          initialValue:
                            currentConfig.footer.exceptionalPass.filled,
                          valuePropName: 'checked',
                        },
                      ]"
                      @change="
                        (val) => setFooterField('exceptionalPass', 'filled', val)
                      "
                    />
                  </a-form-item>
                </div>
                <div class="col-md-4">
                  <a-form-item :label="$t('conseilClass.specCount')">
                    <a-input
                      type="number"
                      v-decorator="[
                        'footer.exceptionalPass.specCount',
                        {
                          initialValue:
                            currentConfig.footer.exceptionalPass.specCount,
                        },
                      ]"
                    />
                  </a-form-item>
                </div>
              </div>
              <a-divider orientation="center">{{
                $t("conseilClass.preParagraph")
              }}</a-divider>
              <div class="row mt-1">
                <div class="col-md-12">
                  <div class="d-flex align-items-center">
                    <quill-editor
                      :value="currentConfig.footer.exceptionalPass.richText"
                      :options="editorOptions"
                      @change="updateExceptionalPassQuill"
                    />
                  </div>
                </div>
              </div>
              <a-divider orientation="left"
                >Tableaux des Admis par dérogation:</a-divider
              >
              <div class="row mt-2">
                <div class="col-md-4">
                  <a-form-item :label="$t('conseilClass.agePass')">
                    <a-switch
                      v-decorator="[
                        'footer.agePass.allow',
                        {
                          initialValue: currentConfig.footer.agePass.allow,
                          valuePropName: 'checked',
                        },
                      ]"
                      @change="(val) => setFooterField('agePass', 'allow', val)"
                    />
                  </a-form-item>
                </div>
                <div class="col-md-4">
                  <a-form-item :label="$t('conseilClass.filled')">
                    <a-switch
                      v-decorator="[
                        'footer.agePass.filled',
                        {
                          initialValue: currentConfig.footer.agePass.filled,
                          valuePropName: 'checked',
                        },
                      ]"
                      @change="(val) => setFooterField('agePass', 'filled', val)"
                    />
                  </a-form-item>
                </div>
                <div class="col-md-4">
                  <a-form-item :label="$t('conseilClass.specCount')">
                    <a-input
                      type="number"
                      v-decorator="[
                        'footer.agePass.specCount',
                        {
                          initialValue: currentConfig.footer.agePass.specCount,
                        },
                      ]"
                    />
                  </a-form-item>
                </div>
              </div>
              <a-divider orientation="center">{{
                $t("conseilClass.preParagraph")
              }}</a-divider>
              <div class="row mt-1">
                <div class="col-md-12">
                  <div class="d-flex align-items-center">
                    <quill-editor
                      :value="currentConfig.footer.agePass.richText"
                      :options="editorOptions"
                      @change="updateAgePassQuill"
                    />
                  </div>
                </div>
              </div>

              <a-divider orientation="left">Tableaux des Réfusers:</a-divider>
              <div class="row mt-2">
                <div class="col-md-4">
                  <a-form-item :label="$t('conseilClass.fail')">
                    <a-switch
                      v-decorator="[
                        'footer.fail.allow',
                        {
                          initialValue: currentConfig.footer.fail.allow,
                          valuePropName: 'checked',
                        },
                      ]"
                      @change="(val) => setFooterField('fail', 'allow', val)"
                    />
                  </a-form-item>
                </div>
                <div class="col-md-4">
                  <a-form-item :label="$t('conseilClass.filled')">
                    <a-switch
                      v-decorator="[
                        'footer.fail.filled',
                        {
                          initialValue: currentConfig.footer.fail.filled,
                          valuePropName: 'checked',
                        },
                      ]"
                      @change="(val) => setFooterField('fail', 'filled', val)"
                    />
                  </a-form-item>
                </div>
                <div class="col-md-4">
                  <a-form-item :label="$t('conseilClass.specCount')">
                    <a-input
                      type="number"
                      v-decorator="[
                        'footer.fail.specCount',
                        {
                          initialValue: currentConfig.footer.fail.specCount,
                        },
                      ]"
                    />
                  </a-form-item>
                </div>
              </div>
              <a-divider orientation="center">{{
                $t("conseilClass.preParagraph")
              }}</a-divider>
              <div class="row mt-1">
                <div class="col-md-12">
                  <div class="d-flex align-items-center">
                    <quill-editor
                      :value="currentConfig.footer.fail.richText"
                      :options="editorOptions"
                      @change="updateFailuill"
                    />
                  </div>
                </div>
              </div>
            </a-tab-pane>
            <a-tab-pane key="4" tab="Dernière page" :forceRender="true">
              <div class="row mt-2">
                <div class="col-md-4">
                  <a-form-item :label="$t('conseilClass.govSpecific')">
                    <a-switch
                      v-decorator="[
                        'lastPage.govSpecific',
                        {
                          initialValue: currentConfig.lastPage.govSpecific,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                  </a-form-item>
                </div>
                <div class="col-md-4">
                  <a-form-item :label="$t('managerAndTeacher.allow')">
                    <a-switch
                      v-decorator="[
                        'lastPage.managerAndTeacher.allow',
                        {
                          initialValue:
                            currentConfig.lastPage.managerAndTeacher.allow,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                  </a-form-item>
                </div>
                <div class="col-md-4">
                  <a-form-item :label="$t('conseilClass.rect')">
                    <a-switch
                      v-decorator="[
                        'lastPage.rect',
                        {
                          initialValue: currentConfig.lastPage.rect,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                  </a-form-item>
                </div>
                <div class="col-md-6">
                  <a-form-item :label="$t('conseilClass.manager')">
                    <a-input
                      v-decorator="[
                        'lastPage.managerAndTeacher.manager',
                        {
                          initialValue:
                            currentConfig.lastPage.managerAndTeacher.manager,
                        },
                      ]"
                    />
                  </a-form-item>
                </div>
                <div class="col-md-6">
                  <a-form-item :label="$t('conseilClass.teacher')">
                    <a-select
                      v-decorator="[
                        'lastPage.managerAndTeacher.teacherList',
                        {
                          initialValue:
                            currentConfig.lastPage.managerAndTeacher
                              .teacherList || [],
                        },
                      ]"
                      show-search
                      mode="tags"
                      :placeholder="$t('emploi.listeEnseignants')"
                      option-filter-prop="children"
                      :filter-option="filterOption"
                      class="w-100"
                    >
                      <a-select-option
                        v-for="teacher in teachers"
                        :key="teacher._id"
                        :value="
                          teacher.employee.firstName +
                          ' ' +
                          teacher.employee.lastName
                        "
                      >
                        {{
                          teacher.employee.firstName +
                          " " +
                          teacher.employee.lastName
                        }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </div>
              </div>
            </a-tab-pane>
          </a-tabs>
        </a-form>
      </div>
      <div class="col-md-6 mt-4">
        <div class="preview-container">
          <div class="preview-header">
            <h3 class="preview-title">
              {{ $t("bulletinBuilder.apercuBulletin") }}
            </h3>
            <div class="preview-controls">
              <div class="preview-actions flex-column align-items-stretch">
                <a-select
                  show-search
                  :value="selectedClasse"
                  :placeholder="$t('emploi.listeClasses')"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  size="large"
                  class="w-100 preview-select mb-2"
                  @change="selectClass"
                >
                  <a-select-option
                    v-for="classe in classes"
                    :key="classe._id"
                    :value="classe._id"
                  >
                    {{ classe.name }}
                  </a-select-option>
                </a-select>
                <a-select
                  show-search
                  :value="selectedTemplateId"
                  :placeholder="$t('conseilClass.selectTemplate')"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  size="large"
                  class="w-100 preview-select mb-2"
                  @change="onTemplateChange"
                >
                  <a-select-option
                    v-for="template in savedTemplates"
                    :key="template._id"
                    :value="template._id"
                  >
                    {{ formatTemplateLabel(template) }}
                  </a-select-option>
                </a-select>
                <div class="preview-buttons">
                  <a-button
                    type="primary"
                    icon="reload"
                    class="preview-btn"
                    @click="renderPDF"
                  >
                    {{ $t("bulletinBuilder.actualiser") }}
                  </a-button>
                </div>
              </div>
            </div>
          </div>
          <a-alert
            v-if="pvMissingKeyStudents.length"
            class="mb-3 mx-2"
            type="warning"
            show-icon
          >
            <template slot="message">
              {{
                $t("conseilClass.pvMissingKeyBanner", {
                  count: pvMissingKeyStudents.length,
                })
              }}
            </template>
            <template slot="description">
              <div>{{ $t("conseilClass.pvMissingKeyHint") }}</div>
              <ul class="mb-0 mt-2 pl-3">
                <li
                  v-for="student in pvMissingKeyStudents.slice(0, 10)"
                  :key="student.id"
                >
                  {{ student.fullName }}
                </li>
                <li v-if="pvMissingKeyStudents.length > 10">
                  {{
                    $t("conseilClass.pvMissingKeyMore", {
                      count: pvMissingKeyStudents.length - 10,
                    })
                  }}
                </li>
              </ul>
            </template>
          </a-alert>
          <div class="preview-content">
            <iframe
              v-if="pdfVisible"
              class="preview-iframe"
              :src="pdfBlobUrl"
              style="
                width: 100%;
                height: calc(100vw * 1.4142);
                max-height: 95vh;
              "
            ></iframe>
            <div v-else class="preview-placeholder">
              <a-spin v-if="printLoading" size="large" />
              <div v-else class="preview-empty">
                <a-icon type="file-pdf" class="preview-icon" />
                <p class="preview-text">
                  {{ $t("bulletinBuilder.selectionnerEleveDabord") }}
                </p>
                <a-button type="primary" @click="renderPDF">
                  <a-icon type="eye" />
                  {{ $t("bulletinBuilder.visualiserBulletin") }}
                </a-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Action Buttons -->
      <div class="col-md-2 offset-md-6 mt-3">
        <a-popconfirm
          :title="$t('all.sureToCancelAlert')"
          :ok-text="$t('all.oui')"
          :cancel-text="$t('all.non')"
          @confirm="undo"
        >
          <a-button type="danger" class="w-100">
            <a-icon type="undo" />
            {{ $t("all.cancel") }}
          </a-button>
        </a-popconfirm>
      </div>
      <div class="col-md-4 mt-3">
        <a-button type="primary" class="w-100" @click="save">
          <a-icon type="save" />
          {{ $t("all.save") }}
        </a-button>
      </div>
    </div>
    <config-modal
      :visible="modalVisible"
      :title="modalTitle"
      :config="modalConfig"
      :defaultData="modalData"
      @cancel="cancalModal"
      @save="saveModalData"
    />
    <table-config-modal
      :visible="modalTableVisible"
      :title="modalTableTitle"
      :config="modelTableConfig"
      :defaultData="{ ...modelTableConfig }"
      :key="modelTableKey"
      @cancel="cancelTableModal"
      @save="saveTableModalData"
    />
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import _ from "lodash";
import printPvClass from "./pvClass";
import "@/views/parametrage/bulletin/components/bulletinBuilder/bulletinBuilder.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";
import MagicUrl from "quill-magic-url";
import ConfigModal from "./ConfigModal.vue";
import apiClient from "@/services/axios";
import {
  DEFAULT_BUILTIN_TEMPLATE_ID,
  normalizeConseilConfig,
} from "./builtinTemplates";
import { buildConseilPvSchoolInfo } from "./pvSchoolInfo";
import { mapState } from "vuex";
Quill.register("modules/magicUrl", MagicUrl);
import draggable from "vuedraggable";
import TableConfigModal from "./TableConfigModal.vue";

// Canonical, complete column order for the admis table. Persisted templates may
// hold an older `columnsOrder` that predates some columns (e.g. "gender"), so we
// reconcile against this list to make sure newly-added, enabled columns are not
// silently dropped from the draggable list and the rendered PDF.
const CANONICAL_ADMIN_TABLE_ORDER = [
  "number",
  "fullName",
  "firstName",
  "lastName",
  "gender",
  "birthDate",
  "birthPlace",
  "uniqueIden",
  "prevYears",
  "trim1",
  "trim2",
  "trim3",
  "moy",
  "decision",
  "handicape",
];

// Merge a persisted order with the canonical one: keep the user's saved ordering
// for columns they already have, then insert any missing canonical column next to
// the canonical neighbour that follows it (so e.g. "gender" lands before
// "birthDate" rather than at the very end).
function reconcileColumnOrder(persisted, canonical) {
  // Keep only known columns and drop duplicates (a corrupted persisted order can
  // contain a column twice, which would produce duplicate draggable keys).
  const result = (persisted || []).filter(
    (col, i, arr) => canonical.includes(col) && arr.indexOf(col) === i
  );
  canonical.forEach((col, idx) => {
    if (result.includes(col)) return;
    let insertAt = result.length;
    for (let j = idx + 1; j < canonical.length; j++) {
      const pos = result.indexOf(canonical[j]);
      if (pos !== -1) {
        insertAt = pos;
        break;
      }
    }
    result.splice(insertAt, 0, col);
  });
  return result;
}

export default {
  name: "PVConfig",
  components: {
    quillEditor,
    ConfigModal,
    TableConfigModal,
    draggable,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
    level: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    configId: {
      type: String,
      default: undefined,
    },
    schoolarYear: {
      type: String,
      default: undefined,
    },
    levelSelectData: {
      type: Object,
      default: () => ({}),
    },
    builletinTypesNames: {
      type: Object,
      default: () => ({}),
    },
    savedTemplates: {
      type: Array,
      default: () => [],
    },
    activeTemplateId: {
      type: String,
      default: DEFAULT_BUILTIN_TEMPLATE_ID,
    },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      selectedClasse: undefined,
      selectedTemplateId: undefined,
      pdfVisible: false,
      printLoading: false,
      currentConfig: normalizeConseilConfig({}),
      classes: [],
      classPvData: [],
      renderWatchHash: "",
      pdfBlobUrl: "",
      quils: {
        tAdmin: "",
        tAdminPost: "",
        exceptionalPass: "",
        agePass: "",
        fail: "",
      },
      editorOptions: {
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            ["link"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }, { script: "under" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],

            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: ["right", "center", "justify", ""] }],

            ["clean"],
          ],
          magicUrl: true,
        },
      },
      modalConfig: {},
      modalData: {
        allow: true,
        auto: true,
        repeatEachPage: true,
        rect: false,
        text: {
          font: "Amiri-Bold",
          color: "#000000",
          size: 14,
        },
      },
      modalTitle: "",
      modalOn: "",
      modalVisible: false,
      lastRender: null,
      sortedColumnsTableAdmin: [],
      avaibleColumnsTableAdmin: [],
      teachers: [],
      formReady: false,
      defaultAdminTableOrder: [
        "number",
        "fullName",
        "firstName",
        "lastName",
        "gender",
        "birthDate",
        "birthPlace",
        "uniqueIden",
        "prevYears",
        "trim1",
        "trim2",
        "trim3",
        "moy",
        "decision",
        "handicape",
      ],
      modelTableConfig: {
        allow: false,
        size: null,
      },
      modalTableVisible: false,
      modalTableOn: "",
      modalTableTitle: "",
      modelTableKey: 1,
      studentsYearsLevel: [],
    };
  },
  computed: {
    ...mapState(["settings", "user"]),
    schoolDetails() {
      return (
        this.user.building.find(
          (el) => el.dbName == this.settings.activeBuilding
        ) || {}
      );
    },
    pvMissingKeyStudents() {
      const students = this.classPvData?.students || [];
      return students.filter(
        (s) => !["A", "C", "P", "R"].includes(s.decisionConseilKey)
      );
    },
  },
  watch: {
    printKey: async function (newVal) {
      if (newVal > 0) {
        await this.printPDF();
      }
    },
    //renderWatchHash: async function (newVal) {
    //  if (newVal != "") await this.renderPDF();
    //  //if (
    //  //  newVal != "" &&
    //  //  (!this.lastRender || (Date.now - startTime) / 1000 > 5)
    //  //)
    //  //  await this.renderPDF();
    //},
    config: {
      immediate: true,
      async handler() {
        this.syncConfig();
        if (this.formReady) await this.loadClasses();
      },
      deep: true,
    },
    level: async function (_) {
      this.selectedClasse = undefined;
      this.classPvData = [];
      await this.loadClasses();
    },
    configId(val) {
      if (val && this.savedTemplates.some((t) => t._id === val)) {
        this.selectedTemplateId = val;
      }
    },
    activeTemplateId(val) {
      if (val) this.selectedTemplateId = val;
    },
    savedTemplates() {
      this.syncSelectedTemplate();
    },
    currentConfig: {
      handler(newVal) {
        // Reconcile the persisted order with the canonical one so newly-added
        // columns (e.g. "gender") still surface when enabled, even on templates
        // saved before those columns existed.
        const orderedColumns = reconcileColumnOrder(
          this.defaultAdminTableOrder,
          CANONICAL_ADMIN_TABLE_ORDER
        );
        const enabledColumns = orderedColumns.filter(
          (column) => newVal.table && newVal.table[column]
        );

        // Only update if columns set truly changed
        if (
          enabledColumns.length !== this.avaibleColumnsTableAdmin.length ||
          !enabledColumns.every((col) =>
            this.avaibleColumnsTableAdmin.includes(col)
          )
        ) {
          this.avaibleColumnsTableAdmin = enabledColumns;
        }
      },
      deep: true,
    },
  },
  created() {
    this.getTeachers();
  },
  async mounted() {
    this.syncConfig();
    await this.$nextTick();
    this.formReady = true;
    await this.$nextTick();
    this.syncFormFields();
    await this.loadClasses();
    this.syncSelectedTemplate();
    this.log();
    window.addEventListener("keydown", this.handleKeydown);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    getTeachers() {
      apiClient
        .post("/teachers/filter", {
          query: { status: "active" },
        })
        .then((res) => (this.teachers = res.data));
    },
    async handleKeydown(e) {
      // Check if Ctrl is pressed
      if (e.ctrlKey) {
        // Block Ctrl+R
        if (e.key === "r" || e.key === "R") {
          e.preventDefault();
          await this.renderPDF();
        }

        // Block Ctrl+S
        if (e.key === "s" || e.key === "S") {
          e.preventDefault();
          this.save();
        }
      }
    },
    attachDettachFromTable(value, on) {
      this.currentConfig.table[on] = value;
      // fullName and firstName/lastName are mutually exclusive in the admis table.
      if (value) {
        if (on === "fullName") {
          this.setTableColumn("firstName", false);
          this.setTableColumn("lastName", false);
        } else if (on === "firstName" || on === "lastName") {
          this.setTableColumn("fullName", false);
        }
      }
    },
    setTableColumn(key, val) {
      this.currentConfig.table[key] = val;
      if (this.formReady) {
        this.form.setFieldsValue({ [`table.${key}`]: val });
      }
    },
    // Keep currentConfig in sync with the footer toggles. getReadyConfig merges
    // currentConfig with the form values; relying on the form value alone let a
    // disabled section (e.g. exceptionalPass.allow = false) still render when the
    // field wasn't captured in the validated values, so mirror it here too.
    setFooterField(section, key, value) {
      if (this.currentConfig.footer && this.currentConfig.footer[section]) {
        this.currentConfig.footer[section][key] = value;
      }
    },
    updateAdminQuill(quilData) {
      this.quils.tAdmin = quilData.html;
    },
    updateAdminPostQuill(quilData) {
      this.quils.tAdminPost = quilData.html;
    },
    updateExceptionalPassQuill(quilData) {
      this.quils.exceptionalPass = quilData.html;
    },
    updateAgePassQuill(quilData) {
      this.quils.agePass = quilData.html;
    },
    updateFailuill(quilData) {
      this.quils.fail = quilData.html;
    },
    async selectClass(classID) {
      this.selectedClasse = classID;
      await apiClient
        .get(`/bulletin/v2/pv/conseil_class/${this.type}/${classID}`)
        .then(({ data }) => {
          this.classPvData = data;
          //const hasAgePass = (data?.students || []).some(
          //  (s) => s.decisionConseilKey === "P"
          //);
          //if (hasAgePass && this.currentConfig.footer?.agePass.allow) {
          //  this.currentConfig.footer.agePass.allow = true;
          //  if (this.formReady) {
          //    this.form.setFieldsValue({ "footer.agePass.allow": true });
          //  }
          //}
        })
        .catch((e) => {
          console.info(e);
          this.$message.warn(this.$t("conseilClass.couldNotGetClassPv"));
        });
      await apiClient
        .get(
          `/bulletin/v2/decision-conseil/classroom/${classID}/${this.settings.activeSchoolarYear}`
        )
        .then(({ data }) => (this.studentsYearsLevel = data || []));

      await this.renderPDF();
    },
    async loadTemplates() {
      this.syncSelectedTemplate();
    },
    syncSelectedTemplate() {
      if (
        this.activeTemplateId &&
        this.savedTemplates.some((t) => t._id === this.activeTemplateId)
      ) {
        this.selectedTemplateId = this.activeTemplateId;
        return;
      }
      if (
        this.configId &&
        this.savedTemplates.some((t) => t._id === this.configId)
      ) {
        this.selectedTemplateId = this.configId;
        return;
      }
      this.selectedTemplateId = DEFAULT_BUILTIN_TEMPLATE_ID;
    },
    formatTemplateLabel(template) {
      const name = template.name || template.type || "";
      if (template.isBuiltin) {
        return `${name} (${this.$t("conseilClass.builtinDefault")})`;
      }
      return name;
    },
    async onTemplateChange(templateId) {
      this.selectedTemplateId = templateId;
      const template = this.savedTemplates.find((t) => t._id === templateId);
      if (template) {
        this.$emit("edit-template", template);
        // Parent swaps in the picked template's config (without remounting us),
        // so wait for the prop/watcher to land, then push the new config into the
        // form fields before the preview reads them.
        await this.$nextTick();
        this.syncFormFields();
        await this.$nextTick();
      }
      if (this.selectedClasse) await this.renderPDF();
    },
    async loadClasses() {
      const level = Number(this.level);
      if (Number.isNaN(level)) {
        this.classes = [];
        return;
      }
      await apiClient
        .post("/classrooms/filter", {
          query: {
            status: "active",
            level,
          },
          aggregation: {
            $project: {
              _id: 1,
              name: 1,
              level: 1,
            },
          },
        })
        .then((res) => (this.classes = res.data));
    },
    cancalModal() {
      this.modalVisible = false;
    },
    async saveModalData(config) {
      const header = {};
      if (this.modalConfig.allow) header.allow = config.allow;
      if (this.modalConfig.auto) header.auto = config.auto;
      if (this.modalConfig.repeatEachPage)
        header.repeatEachPage = config.repeatEachPage;
      if (this.modalConfig.rect) header.rect = config.rect;
      if (this.modalConfig.useSchoolCode)
        header.useSchoolCode = config.useSchoolCode;
      if (this.modalConfig.richText) header.richText = config.richText;
      if (this.modalConfig.textEdit) {
        header.font = config.font;
        header.fontStyle = config.fontStyle;
        header.fontSize = config.fontSize;
        header.color = config.color;
        header.text = config.text;
      }
      this.currentConfig.headers[this.modalOn] = header;
      await this.cancalModal();
      await this.renderPDF();
    },
    syncConfig() {
      this.currentConfig = normalizeConseilConfig(this.config);
      if (this.currentConfig.table.columnsOrder)
        this.defaultAdminTableOrder = this.currentConfig.table.columnsOrder;
      if (this.formReady) {
        this.$nextTick(() => this.syncFormFields());
      }
    },
    syncFormFields() {
      const values = cloneDeep(this.currentConfig);
      const modalOnlyKeys = [
        "text",
        "font",
        "fontStyle",
        "fontSize",
        "color",
        "richText",
        "auto",
      ];
      const stripModalFields = (obj) => {
        if (!obj || typeof obj !== "object") return;
        modalOnlyKeys.forEach((k) => delete obj[k]);
      };
      Object.values(values.headers || {}).forEach(stripModalFields);
      stripModalFields(values.table?.preParagraph);
      stripModalFields(values.table?.postParagraph);
      stripModalFields(values.footer?.exceptionalPass);
      stripModalFields(values.footer?.agePass);
      stripModalFields(values.footer?.fail);
      if (values.table) delete values.table.columnsOrder;
      this.form.setFieldsValue(values);
      this.form.setFieldsValue({
        "lastPage.managerAndTeacher.teacherList":
          this.currentConfig.lastPage?.managerAndTeacher?.teacherList || [],
        "lastPage.managerAndTeacher.manager":
          this.currentConfig.lastPage?.managerAndTeacher?.manager || "",
      });
    },
    undo() {
      this.$emit("undo");
    },
    async save() {
      const config = this.getReadyConfig();
      if (config) this.$emit("save", config);
    },
    async printPDF() {
      console.info("printing");
      this.printLoading = true;
      // do something
      // TODO: print pdf of the selected ClassRoom, using the pdfBlobUrl
      this.printLoading = false;
      //finally emit the end of pdf loading
      this.$emit("donePrinting");
    },
    getReadyConfig() {
      let returns;
      this.form.validateFieldsAndScroll((err, values) => {
        if (err) returns = false;
        const config = _.merge({}, this.currentConfig, values);
        const mt = values.lastPage?.managerAndTeacher;
        if (mt) {
          if (Array.isArray(mt.teacherList)) {
            config.lastPage.managerAndTeacher.teacherList = [...mt.teacherList];
          }
          if (mt.manager !== undefined) {
            config.lastPage.managerAndTeacher.manager = mt.manager;
          }
        }
        if (config.table?.preParagraph?.allow)
          config.table.preParagraph.richText =
            this.quils.tAdmin || config.table.preParagraph.richText;
        if (config.table?.postParagraph?.allow)
          config.table.postParagraph.richText =
            this.quils.tAdminPost || config.table.postParagraph.richText;
        config.footer.exceptionalPass.richText =
          this.quils.exceptionalPass || config.footer.exceptionalPass.richText;
        config.footer.agePass.richText =
          this.quils.agePass || config.footer.agePass.richText;
        config.footer.fail.richText =
          this.quils.fail || config.footer.fail.richText;
        config.table.columnsOrder = this.avaibleColumnsTableAdmin.length
          ? this.avaibleColumnsTableAdmin
          : this.currentConfig.table?.columnsOrder || [];
        returns = config;
      });
      return returns;
    },
    syncStaffToCurrentConfig(config) {
      if (!config?.lastPage?.managerAndTeacher) return;
      this.currentConfig.lastPage.managerAndTeacher.teacherList = [
        ...(config.lastPage.managerAndTeacher.teacherList || []),
      ];
      this.currentConfig.lastPage.managerAndTeacher.manager =
        config.lastPage.managerAndTeacher.manager || "";
    },
    async renderPDF() {
      if (this.selectedClasse) {
        const config = this.getReadyConfig();
        if (config) {
          this.syncStaffToCurrentConfig(config);
          this.printLoading = true;
          this.pdfVisible = false;
          const info = await buildConseilPvSchoolInfo(
            this.settings,
            this.schoolDetails
          );
          this.pdfBlobUrl = await printPvClass(config, this.classPvData, info,this.studentsYearsLevel);
          this.printLoading = false;
          this.pdfVisible = true;
          this.lastRender = Date.now();
        }
      } else this.$message.info(this.$t("conseilClass.selectClassFirst"));
    },
    showTableSetting(on) {
      const entry = this.currentConfig.table?.fontSizes?.[on];
      this.modelTableConfig =
        entry && entry.size
          ? { auto: !!entry.auto, size: entry.size }
          : { auto: true, size: null };

      this.modalTableOn = on;
      this.modalTableTitle =
        on == "gender" ? this.$t("liste.sexe") : this.$t("conseilClass." + on);
      this.modelTableKey++;
      this.modalTableVisible = true;
    },
    cancelTableModal() {
      this.modalTableVisible = false;
    },
    saveTableModalData(data) {
      if (!this.currentConfig.table.fontSizes) {
        this.currentConfig.table.fontSizes = {};
      }
      // `auto` must stay a real boolean. The switch already returns a boolean,
      // so never fold the numeric size into it (data.auto && data.size returned
      // the size, e.g. 2, when auto was re-enabled). A fixed size only applies
      // when auto is off and a size is set; otherwise fall back to auto sizing.
      const auto = !!data.auto;
      const size = Number(data.size) || null;
      this.currentConfig.table.fontSizes[this.modalTableOn] =
        !auto && size ? { auto: false, size } : { auto: true, size: null };
      this.cancelTableModal();
    },
    showSetting(on) {
      switch (on) {
        // these for what to be shown in the modal not their actual value
        case "govText":
          this.modalConfig = {
            allow: true,
            auto: true,
            repeatEachPage: true,
            useSchoolCode: true,
            rect: false,
            textEdit: false,
            richText: false,
          };
          break;
        case "schoolYear":
          this.modalConfig = {
            allow: true,
            auto: false,
            repeatEachPage: true,
            rect: true,
            textEdit: false,
            richText: false,
          };
          break;
        case "mainTitle":
          this.modalConfig = {
            allow: false,
            auto: false,
            repeatEachPage: false,
            rect: false,
            textEdit: true,
            richText: false,
          };
          break;
        case "secondaryText":
          this.modalConfig = {
            allow: false,
            auto: false,
            repeatEachPage: false,
            rect: false,
            textEdit: true,
            richText: false,
          };
          break;
        case "preParagraph":
          this.modalConfig = {
            allow: true,
            auto: false,
            repeatEachPage: true,
            rect: true,
            textEdit: false,
            richText: true,
          };
          break;
        case "govLog":
          this.modalConfig = {
            allow: true,
            auto: false,
            repeatEachPage: true,
            rect: false,
            textEdit: false,
            richText: false,
          };
          break;
        case "schoolLogo":
          this.modalConfig = {
            allow: true,
            auto: false,
            repeatEachPage: true,
            rect: false,
            textEdit: false,
            richText: false,
          };
          break;
        case "stats":
          this.modalConfig = {
            allow: true,
            auto: false,
            repeatEachPage: true,
            rect: true,
            textEdit: false,
            richText: false,
          };
          break;
      }
      if (this.modalConfig.allow)
        this.modalData.allow = this.currentConfig?.headers[on]?.allow;
      if (this.modalConfig.auto)
        this.modalData.auto = this.currentConfig?.headers[on]?.auto;
      if (this.modalConfig.useSchoolCode)
        this.modalData.useSchoolCode =
          this.currentConfig?.headers[on]?.useSchoolCode;
      if (this.modalConfig.repeatEachPage)
        this.modalData.repeatEachPage =
          this.currentConfig?.headers[on]?.repeatEachPage;
      if (this.modalConfig.rect)
        this.modalData.rect = this.currentConfig?.headers[on]?.rect;
      if (this.modalConfig.richText)
        this.modalData.richText = this.currentConfig?.headers[on]?.richText;
      if (this.modalConfig.textEdit) {
        this.modalData.text = {
          font: this.currentConfig?.headers[on]?.font,
          fontStyle: this.currentConfig?.headers[on]?.fontStyle,
          fontSize: this.currentConfig?.headers[on]?.fontSize,
          color: this.currentConfig?.headers[on]?.color,
          text: this.currentConfig?.headers[on]?.text,
        };
      }
      console.info({ currentConfig: this.currentConfig, data: this.modalData });
      this.modalOn = on;
      this.modalVisible = true;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>
<style>
.ql-editor {
  height: 100px;
}
.ql-tooltip {
  z-index: 3;
}
/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.full {
  width: 100%;
}
.drag-container {
  gap: 12px;
}

.drag-chip {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  margin: 10px;
  background-color: #f1f5f9;
  border: 1px solid #d1d5db;
  min-width: 90px;
  cursor: grab;
  transition: background-color 0.2s, transform 0.1s;
}

.drag-chip:hover {
  background-color: #e2e8f0;
}

.circle-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  background-color: #3b82f6;
  color: white;
  border-radius: 50%;
  font-size: 12px;
  margin-right: 6px;
  flex-shrink: 0;
}
</style>
